module.exports = __webpack_public_path__ + "img/longzi.b4ef3d2f.png";